export default __webpack_public_path__ + "static/media/user.26830294.svg";